import React, { useState } from "react";
import "./style.css";
import Logo from "../../Images/New/Products/easyGst.webp"
import h1 from "../../Images/New/Hero/1.gif"
import h2 from "../../Images/New/Hero/2.gif"
import h3 from "../../Images/New/Hero/3.gif"
import h4 from "../../Images/New/Hero/4.gif"
import h5 from "../../Images/New/Hero/5.gif"
import h6 from "../../Images/New/Hero/6.gif"
import h7 from "../../Images/New/Hero/7.gif"
import h8 from "../../Images/New/Hero/8.gif"
import { Link } from "react-scroll";
import AllFeatures from "../AllFeatures/Allfeatures1";


const Hero = React.memo(() => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  }
  return (
    <>
      <div className="h-screen flex flex-col items-center justify-center">
        <div className="box">
          <div className="wave -one"></div>
          <div className="wave -two"></div>
          <div className="wave -three"></div>
        </div>
        <div
          className={`absolute z-40 mt-[1100px] sm:mt-12 w-full flex flex-col justify-center items-center max-w-7xl`}
        >
          <div className={`sm:flex block items-center ${isExpanded ? 'mt-[500px] sm:mt-[300px]' : ''}`}>
            <div className="sm:w-1/2 flex flex-col justify-start items-start px-3">
              {/* <p className="mb-0 text-black text-3xl font-medium py-3">
                EasyGST
              </p> */}
              <img src={Logo} alt="Logo" className="w-[40%] mb-3" />
              {/* <img src={PLogo} className="w-40 h-16" alt="" /> */}
              <p className="mb-0 text-black text-[2.6rem] leading-[2.8rem] font-bold">
                Best GST Return Filing & Reconciliation Software
              </p>
              <p className="mb-0 text-black text-xl font-semibold py-3">
                Simplify GST Return filing & Reconciliation with EasyGST
                Software
              </p>
              <p className="mb-3 text-black text-lg">
                EasyGST is one of the best Goods and Services tax software for
                Chartered Accountants (CA), Tax professionals & businesses in
                India for the easiest GST return filing. EasyGST is developed to
                make GST related workflow quick, smooth & accurate. Experience
                the power of simplified GST compliance with EasyGST Software's
                free demo download!
              </p>
              {isExpanded && (
                <div>
                  <p className="mb-3 text-black text-lg">
                    EasyGST software supports direct uploading of GST returns,
                    reconciliation module for GSTR 2A, GSTR 2B with accounts,
                    MIS reports and analysis, data backup & restore, verifying
                    bulk GSTIN and simplifying GST management with the
                    comprehensive Dashboard. It further helps to track ITC
                    (Input Tax Credit) match/mismatch for invoice
                    reconciliation. It prepares & file GST returns such as GSTR
                    1, GSTR 3B, GSTR 4, GST CMP 08, GSTR 7, GSTR 9, GSTR 9C,
                    etc.
                  </p>
                  <p className="mb-3 text-black text-lg">
                    with ease. EasyGST return filing software provides a
                    single-window dashboard design with access to all the
                    necessary features and tax filing capabilities with easy and
                    user-friendly operations. This return filing software is
                    exclusively designed and developed as per GST guidelines.
                  </p>
                </div>
              )}
              <button onClick={toggleExpand} className="mb-2 cursor-pointer">
                {isExpanded ? "Show Less" : "Show More"}
              </button>
              <div className="flex flex-wrap sm:space-x-4">
                <a
                  href="https://www.easyofficesoftware.com/bank_details"
                  className=" bg-black py-3 px-5 text-white rounded-full text-lg font-bold border-none hover:bg-white hover:text-black duration-200 hover:shadow-xl"
                  target="_blank"
                  rel="noreferrer"
                >
                  Buy Now
                </a>
                <a
                  href="https://www.easyofficesoftware.com/product_catalogue"
                  className=" bg-black py-3 px-5 text-white rounded-full text-lg font-bold border-none hover:bg-white hover:text-black duration-200 hover:shadow-xl ml-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Catalogue
                </a>
                <Link to="Video">
                  <button
                    className=" bg-black py-3 px-5 text-white rounded-full text-lg font-bold border-none hover:bg-white hover:text-black duration-200 hover:shadow-xl mt-3 sm:mt-0 sm:ml-3"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Video Demo
                  </button>
                </Link>
                <a
                  href="https://www.easyofficesoftware.com/easygst"
                  className=" bg-black py-3 px-5 text-white rounded-full text-lg font-bold border-none hover:bg-white hover:text-black duration-200 hover:shadow-xl mt-3 sm:mt-0 ml-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn More
                </a>
              </div>
            </div>
            <div className="sm:w-1/2 pt-8 px-8 mt-10 sm:mt-0 bg-white rounded-2xl shadow-lg">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    GST Returns e-filing
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Data Import & Export
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    ITC Reconciliation <br />
                    with Accounts
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Annual Return &<br /> Audit Report
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Comprehensive Dashboard
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Online Data link <br />
                    with GST portal
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Multi-Angle Data <br />
                    Analysis & Reports
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Pre-validation to <br />
                    rectify errors
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-end mt-2 max-w-7xl">
                <a
                  href="https://www.easyofficesoftware.com/easygst"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-end"
                >
                  <p className="mb-0 mr-1 text-black text-lg font-bold">
                    Learn More
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right mt-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          isExpanded ? " sm:mt-[300px] mt-[1550px]" : "sm:mt-0 mt-[1000px]"
        }`}
      >
        <AllFeatures />
      </div>
    </>
  );
});

export default Hero;
